import React from 'react'
import { Tooltip } from 'antd'
import menuBuilderMenusCopy from 'src/constants/menuBuilderCopy'
import { getMenuGpChipDisplay } from 'src/utils/menuSalesMixDisplay'
import { getGpBandChipStyle } from 'src/utils/recipeGp'

const chipStyles = {
  weighted: {
    color: '#ad6800',
    backgroundColor: '#fff7e6',
    border: '1px solid #ffd591',
  },
  revenue: {
    color: '#0958d9',
    backgroundColor: '#e6f4ff',
    border: '1px solid #91caff',
  },
}

const baseChipStyle = {
  fontWeight: 'normal',
  fontSize: '12px',
  padding: '2px 6px',
  borderRadius: '4px',
  display: 'inline-block',
}

const MenuGpChip = ({ variant, gp, children, title }) => {
  const chipStyle =
    variant === 'avg' && gp != null
      ? getGpBandChipStyle(gp)
      : chipStyles[variant]

  const chip = (
    <span style={{ ...baseChipStyle, ...chipStyle }}>{children}</span>
  )

  if (title) {
    return <Tooltip title={title}>{chip}</Tooltip>
  }

  return chip
}

const MenuGpChips = ({ menu }) => {
  const chips = getMenuGpChipDisplay(menu)
  const copy = menuBuilderMenusCopy

  if (
    chips.avgGp == null &&
    chips.weightedGp == null &&
    !chips.estimatedTotalGpLabel
  ) {
    return null
  }

  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '6px',
        marginTop: '8px',
      }}
    >
      {chips.avgGp != null ? (
        <MenuGpChip variant='avg' gp={chips.avgGp}>
          {copy.menuHeaderAvgGpLabel.replace('{gp}', String(chips.avgGp))}
        </MenuGpChip>
      ) : null}
      {chips.weightedGp != null ? (
        <MenuGpChip variant='weighted' title={copy.salesMixWeightedGpHelp}>
          {copy.menuCardWeightedGpLabel.replace(
            '{gp}',
            String(chips.weightedGp),
          )}
        </MenuGpChip>
      ) : null}
      {chips.estimatedTotalGpLabel ? (
        <MenuGpChip variant='revenue'>
          {copy.menuCardEstGpLabel.replace(
            '{amount}',
            chips.estimatedTotalGpLabel,
          )}
        </MenuGpChip>
      ) : null}
    </div>
  )
}

export default MenuGpChips
